<template>
	<v-app theme="light" style="background-color: #eeeeee">
		<nav-bar-portal />
		<VMain>
			<v-container fluid class="pt-0">
				<v-row>
					<v-col cols="12">
						<v-row
							align="center"
							justify="center"
							class="darkColor--text grey lighten-5 rounded mx-5 py-2"
						>
							<v-col cols="12">
								<h1 style="margin: auto">
									<!-- <v-icon class="grey--text text--lighten-1 mt-16 mt-md-0" style="font-size: 2em">fas fa-face-smile-beam</v-icon>
									<br /> -->
									Good {{ getGreetingTime() }}, {{ clientName }}!
								</h1>
								<!-- <v-menu
									offset-y
									class="h-100 mx-5"
									open-on-hover
									right
									v-model="teamMenuActive"
								>
									<template v-slot:activator="{ on, attrs }">
										<v-btn
											:ripple="false"
											v-bind="attrs"
											v-on="on"
											x-large
											height="auto"
											light
											elevation="0"
											outlined
											absolute 
											top 
											right
											class="text-left py-md-2 mx-4 px-md-4 text-transform-none rounded-lg float-right"
										>
											<div class="pa-1 mr-3">
												<b> {{ clientName }} Team </b>
												<small style="display: block;">
													{{ clientUserCount
													}}{{
														clientUserCount == 0
															? "Overview"
															: clientUserCount == 1
															? " member"
															: " members"
													}}
												</small>
											</div>
											<v-icon right small v-if="teamMenuActive">
												fas fa-chevron-up
											</v-icon>
											<v-icon right small v-else>
												fas fa-chevron-down
											</v-icon>
										</v-btn>
									</template>
									<v-list class="py-0">
										<v-list-item to="/team">
											<v-list-item-title>See team members</v-list-item-title>
										</v-list-item>
									</v-list>
								</v-menu> -->
							</v-col>
							<v-col style="display: flex; padding-top: 0; padding-bottom: 0;">
								<v-col cols="7" class="pa-0">
									<h3 class="pl-6 font-weight-high"
										v-if="getNotifications.length > 0">
										Here's what happened while you were away:
									</h3>
									<notifications
										shouldDisplaySingle
										:shouldMarkAsRead="false"
										:maxNotifications= 4
										:isPortalPage="true"
									></notifications>
								</v-col>
								<v-col cols="1"></v-col>
								<v-col style="margin-right: 5px">		
									<router-link :to="'/team/' + username" 
										style="text-decoration: none; color: black;  float: right; border: black 1px solid; padding: 5px 10px; border-radius: 4px;">
										<h3 style="cursor: pointer;"> {{ name }}</h3>
									</router-link>

									<v-text class="mt-5 ml-1 pa-3" style="float: left; border-radius: 5px; background: #00800006;">
										At Orixe, we believe that ethical supply chains are the foundation of a sustainable future. By fostering transparency and trust, we enable businesses
										to not only meet today's demands for accountability but also lead the way in creating a positive legacy for people and the planet.
										<h3 class="mt-5 primary--text" style="float: right;">
											"Is your supply chain Orixed?"</h3>
									</v-text>
									
									<v-btn
										color="#DE8F18"
										class="white--text mt-5"
										style="width: 162px; font-size: 1em; height: 30px; float: right;"
										@click="dialogSupport()"
									>
										FAQ & Support
									</v-btn>
								</v-col>
							</v-col>
						</v-row>

						<v-row
							justify="center"
							align="center"
							class="grey lighten-5 rounded mx-5 my-3"
							style="padding-left: 2%; padding-right: 2%;"
						>
							<v-col cols="12" class="flex-grow-0 mt-2 pa-0">
								<h2 class="text-center pb-0">Modules</h2>
							</v-col>
							<v-col cols="12" class="pa-1 pa-sm-2">
								<div class="modules-row">
									<div
										v-for="mod in portalModules"
										:key="mod.key"
										class="module-item"
									>
										<v-tooltip
											bottom
											:disabled="!mod.lockTooltip || mod.unlocked"
										>
											<template v-slot:activator="{ on, attrs }">
												<v-card
													class="module-card text-center"
													color="white"
													light
													elevation="2"
													v-bind="attrs"
													v-on="on"
													:class="{ portaldisabled: mod.lockTooltip && !mod.unlocked }"
													:to="mod.to || undefined"
													@click="onModuleClick(mod)"
												>
													<div class="module-card-inner">
														<img
															:alt="mod.label"
															:src="mod.icon"
															class="module-icon"
														/>
														<h4 class="module-label">{{ mod.label }}</h4>
														<v-icon
															v-if="mod.lockTooltip && !mod.unlocked"
															class="module-lock"
															small
														>
															fas fa-lock
														</v-icon>
													</div>
												</v-card>
											</template>
											<span>{{ mod.lockMessage }}</span>
										</v-tooltip>
									</div>
								</div>
							</v-col>
						</v-row>

						<v-row
							justify="space-around"
							align="stretch"
							class="grey lighten-5 rounded mx-5 mb-3 csr-portal-row"
						>
							<v-col cols="12" md="6" class="pa-4 d-flex flex-column">
								<supplier-csr
									:isPortalView="true"
									:score1="csrScore[0]"
									:score2="csrScore[1]"
									:score3="csrScore[2]"
									:score4="csrScore[3]"
									:title="`Sustainability for ${clientName}`"
								/>
								<v-btn
									class="csr-portal-btn mt-4"
									color="primary"
									block
									to="/csr/submit"
									:disabled="csrScore[0] > 0"
								>
									<v-icon left small>fas fa-user-friends</v-icon>
									Get the Sustainability score for your company
								</v-btn>
							</v-col>
							<v-col cols="12" md="6" class="pa-4 d-flex flex-column">
								<supplier-csr
									:isPortalView="true"
									:score1="csrAverageScore[0]"
									:score2="csrAverageScore[1]"
									:score3="csrAverageScore[2]"
									:score4="csrAverageScore[3]"
									:title="`Average Sustainability Score for Your Connections`"
								/>
								<v-btn
									class="csr-portal-btn mt-4"
									color="primary"
									block
									to="/csr/request"
								>
									<v-icon left small>fas fa-user-plus</v-icon>
									Invite supplier to fill out Sustainability form
								</v-btn>
							</v-col>
						</v-row>

						<v-row
							justify="space-around"
							align="stretch"
							class="grey lighten-5 rounded mx-5 mb-3 csr-portal-row"
						>
							<v-col cols="12" md="6" class="pa-4 d-flex flex-column">
								<nis-score-rings
									:isPortalView="true"
									:score1="nisScore[0]"
									:score2="nisScore[1]"
									:score3="nisScore[2]"
									:score4="nisScore[3]"
									:score5="nisScore[4]"
									:score6="nisScore[5]"
									:title="`NIS Cyber Security for ${clientName}`"
								/>
								<v-btn
									class="csr-portal-btn mt-4"
									color="primary"
									block
									to="/nis"
									:disabled="nisScore[0] != null"
								>
									<v-icon left small>fas fa-user-friends</v-icon>
									Get the NIS score for your company
								</v-btn>
							</v-col>
							<v-col cols="12" md="6" class="pa-4 d-flex flex-column">
								<nis-score-rings
									:isPortalView="true"
									:score1="nisAverageScore[0]"
									:score2="nisAverageScore[1]"
									:score3="nisAverageScore[2]"
									:score4="nisAverageScore[3]"
									:score5="nisAverageScore[4]"
									:score6="nisAverageScore[5]"
									:title="`Average NIS Score for Your Connections`"
								/>
								<v-btn
									class="csr-portal-btn mt-4"
									color="primary"
									block
									to="/nis/request"
								>
									<v-icon left small>fas fa-user-plus</v-icon>
									Invite supplier to fill out NIS form
								</v-btn>
							</v-col>
						</v-row>
						
					</v-col>
				</v-row>
			</v-container>
			<v-dialog v-model="supportOrixe" max-width="800px">
				<v-card class="text-center" style="padding: 0 20px 80px 20px;">
					<v-toolbar
						elevation="0"
						class="pr-0"	
					>
						<v-col align="right" class="pr-1">
							<v-btn icon @click="supportOrixe = false">
								<v-icon large color="primary">fas fa-thin fa-times</v-icon>
							</v-btn>
						</v-col>
					</v-toolbar>
					<br>
					<span class="text-h6">If you need help you can contact support: <b class="primary--text">support@orixe.eu</b></span><br>
					<span class="text-h6">or</span><br>
					<!-- <span class="text-h6">
						<v-btn 
							color="orangeButton"
							class="white text-h7"
							target="_blank"
						><a target="_blank" href="https://www.orixe.eu/knowledge-page" style="text-decoration: none; color: white">Info & FAQ page <v-icon class="pl-2">fas fa-external-link-alt</v-icon></a></v-btn>
					</span> -->
					<span class="text-h6">
						<v-btn 
							color="orangeButton"
							class="white text-h7"
							:to="'/knowledge'"
							target="_blank"
							>
							<a style="text-decoration: none; color: white">Knowledge page<v-icon class="pl-2">fas fa-external-link-alt</v-icon></a>
						</v-btn>
					</span>
					<span class="text-h6">
						<v-btn 
							color="orangeButton"
							class="white text-h7 ml-10"
							target="_blank"
						><a target="_blank" href="https://outlook.office.com/book/BookaDemo1@orixe.eu/" style="text-decoration: none; color: white">Book a Teams meeting<v-icon class="pl-2">fas fa-external-link-alt</v-icon></a></v-btn>
					</span>
				</v-card>
			</v-dialog>
			<!--
			Old module for sustainability, can most probably be removed. 
			<v-dialog v-model="dialog" max-width="500px">
				<v-card>
					<v-card-title>What would you like to access?</v-card-title>
					<v-card-text>
						<v-row class="contentRow">
							<v-btn
								width="60%"
								class="mx-auto"
								color="success"
								@click="redirect('/csr')"
							>
								Sustainability
							</v-btn>
						</v-row>
						<v-row class="contentRow">
							<v-btn
								width="60%"
								class="mx-auto"
								color="success"
								@click="redirect('/emissions')"
							>
								Emission
							</v-btn>
						</v-row>
					</v-card-text>
					<v-card-actions>
						<v-btn color="error" text outlined @click="dialog = false"
							>Close</v-btn
						>
					</v-card-actions>
				</v-card>
			</v-dialog>
			-->
			<orixe-footer/>
		</VMain>
		<test-error />
	</v-app>
</template>

<script>
import router from "../router"
import { mapGetters, mapActions } from "vuex"
import BillingAPI from "../api/billing"
import CsrAPI from "../api/csr/csr"
import SupplierAPI from "../api/csr/supplier"
import NisApi from "../api/nis/nis"
import NisScoreRings from "../components/NisScoreRings.vue"
import LoadingState from "../consts/LoadingState"

export default {
	name: "Login",
	components: {
		"nis-score-rings": NisScoreRings,
	},
	data() {
		return {
			unlocked: false,
			billingPortalURL: null,
			//billingPortalURL2: null,
			csrScore: [null, null, null, null],
			csrAverageScore: [null, null, null, null],
			nisScore: [null, null, null, null, null, null],
			nisAverageScore: [null, null, null, null, null, null],
			dialog: false,
			teamMenuActive: false,
			supportOrixe: false,
			connections: [],
		}
	},
	computed: {
		...mapGetters("notifications/notifications", ["getNotifications"]),
		auditUnlocked() {
			return this.$accessToRoute("/audit")
		},
		auditFlowDownUnlocked() {
			return this.$accessToRoute("/auditflowdown")
		},
		traceUnlocked() {
			return this.$accessToRoute({ name: "Trace" })
		},
		connectionsUnlocked() {
			return this.$accessToRoute("/connections")
		},
		nisUnlocked() {
			return this.$accessToRoute("/nis")
		},
		portalModules() {
			return [
				{
					key: "audit",
					label: "Audit",
					icon: require("../assets/Modules/Audit.svg"),
					unlocked: this.auditUnlocked,
					to: this.auditUnlocked ? "/audit" : null,
					lockTooltip: true,
					lockMessage: "Contact us to get started with Audit!",
				},
				{
					key: "audit-flow-down",
					label: "Audit Flow-Down",
					icon: require("../assets/Modules/Audit.svg"),
					unlocked: this.auditFlowDownUnlocked,
					to: this.auditFlowDownUnlocked ? "/auditflowdown" : null,
					lockTooltip: true,
					lockMessage: "Contact us to get started with Audit!",
				},
				{
					key: "trace",
					label: "Trace",
					icon: require("../assets/Modules/Trace.svg"),
					unlocked: this.traceUnlocked,
					to: this.traceUnlocked ? "/trace" : null,
					lockTooltip: true,
					lockMessage: "Contact us to get started with Trace!",
				},
				{
					key: "sustainability",
					label: "Sustainability",
					icon: require("../assets/Modules/Sustainability.svg"),
					unlocked: true,
					clickPath: "/csr",
					lockTooltip: false,
				},
				{
					key: "nis",
					label: "NIS",
					icon: require("../assets/Modules/NIS.svg"),
					unlocked: this.nisUnlocked,
					clickPath: this.nisUnlocked ? "/nis" : null,
					lockTooltip: true,
					lockMessage: "You need NIS Coordinator or NIS Auditor role to access NIS.",
				},
				{
					key: "co2",
					label: "Co2 Calculator",
					icon: require("../assets/Modules/Ikon_CO2_Modul.svg"),
					unlocked: true,
					clickPath: "/emissions",
					lockTooltip: false,
				},
				{
					key: "connections",
					label: "Connections",
					icon: require("../assets/Modules/Connections.svg"),
					unlocked: this.connectionsUnlocked,
					to: this.connectionsUnlocked ? "/connections" : null,
					lockTooltip: true,
					lockMessage: "Contact us to get started with Connections!",
				},
				{
					key: "supplier-performance",
					label: "Supplier Performance",
					icon: require("../assets/Modules/SupplierPerformance.svg"),
					unlocked: true,
					to: "/supplier-performance",
					lockTooltip: false,
				},
			]
		},
		...mapGetters("user", ["isLoggedIn", "getUser"]),
		username() {
			return this.getUser.username
		},
		name() {
			return this.getUser.firstname && this.getUser.lastname
				? this.getUser.firstname + " " + this.getUser.lastname
				: this.clientName
		},
		clientID() {
			return this.getUser.clientID
		},
		clientName() {
			return this.getUser.clientName
		},
		clientUserCount() {
			return this.getUser.clientUserCount
		}
	},
	watch: {
		isLoggedIn: function(newval) {
			if (newval == false) {
				router.push("/login")
			}
		}
	},
	methods: {
		...mapActions("notifications/notifications", [
			"deleteAllNotifications",
			"deleteNotification",
			"loadNotifications"
		]),
		dialogSupport(){
			this.supportOrixe = true
		},
		onModuleClick(mod) {
			if (mod.lockTooltip && !mod.unlocked) {
				return
			}
			if (mod.clickPath) {
				this.redirect(mod.clickPath)
			}
		},
		showOptions() {
			this.dialog = true
		},
		redirect(path) {
			this.$router.push(path)
		},
		getGreetingTime() {
			let n = this.$moment()
			if (n && n.isValid()) {
				var e = parseFloat(n.format("HH"))
				return e >= 12 && e <= 17
					? "afternoon"
					: e >= 17
						? "evening"
						: "morning"
			}
		},
		getBillingPortal() {
			BillingAPI.getBillingPortalURL().then(url => {
				if (url) {
					this.billingPortalURL = url
				}
			})
		},
		// postBillingPortal() {
		// 	BillingAPI.postBillingPortalURL().then(url => {
		// 		if (url) {
		// 			this.billingPortalURL2 = url
		// 		}
		// 	})
		// },
		getCsrScore() {
			this.csrScore = [null, null, null, null]

			CsrAPI.getCSRForm()
				.then(data => {
					if (data.csrID) {
						CsrAPI.getCSRAssessment(data.csrID)
							.then(result => {
								let csr = result[0]
								if (csr) {
									this.csrScore = [
										Math.round(csr.score1),
										Math.round(csr.score2),
										Math.round(csr.score3),
										Math.round(csr.score4)
									]
								}
							})
							.catch(error => {
								console.log(error)
							})
					}
				})
				.catch(err => {
					console.log(err)
				})
		},
		loadItems() {
			this.$store.dispatch(
				"loading/" + LoadingState.ACTION_START_LOADING,
				null,
				{ root: true }
			)
			SupplierAPI.getSuppliers()
				.then((data) => {
					this.connections = []
					for (let entry of data) {
						this.connections.push({
							clientID: entry.clientID,
							name: entry.name,
							csr: entry.csr,
							averageConnectionScores: entry.averageSupplierScores,
							remove: null,
						})
					}
					this.getCsrAverageScore() // Calculating average score of all suppliers
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_END_LOADING,
						null,
						{ root: true }
					)
				})
				.catch((error) => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_SET_ERROR,
						error,
						{ root: true }
					)
				})
		},
		getCsrAverageScore(){
			var count, sumScore1, sumScore2, sumScore3, sumScore4
			count = sumScore1 = sumScore2 = sumScore3 = sumScore4 = 0
			for(let connection of this.connections){
				if(connection.csr){
					count++
					sumScore1 += connection.csr.score1 
					sumScore2 += connection.csr.score2 
					sumScore3 += connection.csr.score3 
					sumScore4 += connection.csr.score4 
				}
			}
			if (!count) {
				this.csrAverageScore = [null, null, null, null]
				return
			}
			const averageScore1 = sumScore1/count 
			const averageScore2 = sumScore2/count 
			const averageScore3 = sumScore3/count 
			const averageScore4 = sumScore4/count 

			this.csrAverageScore = [averageScore1, averageScore2, averageScore3, averageScore4]
		},
		getNisScore() {
			this.nisScore = [null, null, null, null, null, null]
			NisApi.getNisAssessmentsAll()
				.then((data) => {
					// API wraps the list: data = [assessmentsArray]
					const list = Array.isArray(data?.[0])
						? data[0]
						: Array.isArray(data)
							? data
							: []
					if (!list.length) {
						return
					}
					const sorted = [...list].sort((a, b) => {
						const ta = a.timestamp ? new Date(a.timestamp).getTime() : 0
						const tb = b.timestamp ? new Date(b.timestamp).getTime() : 0
						return tb - ta
					})
					const latest = sorted[0]
					if (!latest || typeof latest !== "object") {
						return
					}
					this.nisScore = [
						latest.score1 == null ? null : Math.round(latest.score1),
						latest.score2 == null ? null : Math.round(latest.score2),
						latest.score3 == null ? null : Math.round(latest.score3),
						latest.score4 == null ? null : Math.round(latest.score4),
						latest.score5 == null ? null : Math.round(latest.score5),
						latest.score6 == null ? null : Math.round(latest.score6),
					]
				})
				.catch((err) => {
					console.log(err)
				})
		},
		getNisAverageScore() {
			this.nisAverageScore = [null, null, null, null, null, null]
			NisApi.getNisSuppliers()
				.then((data) => {
					let count = 0
					const sums = [0, 0, 0, 0, 0, 0]
					for (const entry of data || []) {
						if (!entry.nis) {
							continue
						}
						count++
						sums[0] += entry.nis.score1 == null ? 0 : Number(entry.nis.score1)
						sums[1] += entry.nis.score2 == null ? 0 : Number(entry.nis.score2)
						sums[2] += entry.nis.score3 == null ? 0 : Number(entry.nis.score3)
						sums[3] += entry.nis.score4 == null ? 0 : Number(entry.nis.score4)
						sums[4] += entry.nis.score5 == null ? 0 : Number(entry.nis.score5)
						sums[5] += entry.nis.score6 == null ? 0 : Number(entry.nis.score6)
					}
					if (!count) {
						return
					}
					this.nisAverageScore = sums.map((sum) => Math.round(sum / count))
				})
				.catch((err) => {
					console.log(err)
				})
		},
	},
	mounted() {
		this.getBillingPortal()
		//this.postBillingPortal()
		this.getCsrScore()
		this.loadItems()
		this.getCsrAverageScore()
		this.getNisScore()
		this.getNisAverageScore()
		this.loadNotifications({})
	}
}
</script>

<style scoped>
.portaldisabled {
	background-color: #0b707844 !important;
	background-image: linear-gradient(
		45deg,
		white 25%,
		#0b707844 25.5%,
		#0b707844 50%,
		white 50.5%,
		white 75%,
		#0b707844 75.5%,
		#0b707844
	);
	background-size: 20px 20px;
	background-repeat: repeat;
}

.text-transform-none {
  text-transform:none !important;
}

.sustainabilityScore{
	margin-top: 0;
}

.csr-portal-row {
	margin-top: 8px;
}

.csr-portal-btn {
	text-transform: none !important;
	height: 40px !important;
	font-size: 0.85rem !important;
	letter-spacing: 0 !important;
	white-space: normal !important;
	line-height: 1.2 !important;
}

.modules-row {
	display: flex;
	flex-wrap: nowrap;
	align-items: flex-start;
	justify-content: center;
	gap: 16px;
	width: 100%;
	padding: 8px 0 16px;
	box-sizing: border-box;
}

.module-item {
	/* Same square size for every module; shrink together on smaller laptops */
	flex: 0 0 auto;
	width: min(150px, calc((100% - 112px) / 8));
}

.module-item >>> .v-tooltip {
	display: block !important;
	width: 100% !important;
}

.module-card {
	width: 100% !important;
	height: 0 !important;
	padding: 0 0 100% 0 !important; /* force perfect square */
	margin: 0 !important;
	background-color: #ffffff !important;
	border-radius: 4px !important;
	box-shadow: 0 2px 6px rgba(0, 0, 0, 0.12) !important;
	position: relative !important;
	overflow: hidden;
	box-sizing: border-box;
}

.module-card-inner {
	position: absolute;
	inset: 0;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	padding: 14px 10px;
	box-sizing: border-box;
}

.module-icon {
	width: 50%;
	max-width: 75px;
	aspect-ratio: 1 / 1;
	object-fit: contain;
	display: block;
	flex: 0 0 auto;
}

.module-label {
	margin: 10px 0 0 !important;
	font-size: 0.95rem;
	line-height: 1.15;
	font-weight: 600;
	color: #212121;
	max-width: 100%;
	min-height: 2.3em;
	display: flex;
	align-items: center;
	justify-content: center;
	text-align: center;
	overflow-wrap: anywhere;
}

.module-lock {
	position: absolute;
	right: 8px;
	bottom: 8px;
}

@media (max-width: 1100px) {
	.module-label {
		font-size: 0.75rem;
	}
}

@media (max-width: 900px) {
	.modules-row {
		gap: 10px;
	}
	.module-item {
		width: min(150px, calc((100% - 70px) / 8));
	}
	.module-label {
		font-size: 0.65rem;
		margin-top: 6px !important;
	}
}
</style>
